import React from 'react';

export default function Footer() {
  return (
    <footer className="py-3">
      <p className="text-center mb-0">
        <i className="fa fa-heartbeat me-1" style={{ color: '#0d9488' }}></i>
        Green Naturopathy &copy; 2026–2027. All rights reserved.
      </p>
    </footer>
  );
}